import * as swcHelpers from '@swc/helpers';
import { useNewsletterSubscribe } from './use-newsletter-subscribe.js';
import { useBloomreach } from '../context/context.js';
import { getContentByRef } from '../utils/get-content-by-ref.js';

const useBloomreachNewsletterData = ()=>{
    var ref, ref1;
    const newsletterSubscribe = useNewsletterSubscribe();
    /**
   * Get the newsletter content from the BR Newsletter static document
   */ const { pageModel  } = useBloomreach();
    const ref2 = (ref = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.models) === null || ref === void 0 ? void 0 : (ref1 = ref.newsletterConfiguration) === null || ref1 === void 0 ? void 0 : ref1.$ref;
    const { richTextAfter , richTextBefore , title  } = getContentByRef(ref2, pageModel) || {};
    return swcHelpers.objectSpread({}, newsletterSubscribe, {
        contentAfterSubmit: richTextAfter === null || richTextAfter === void 0 ? void 0 : richTextAfter.value,
        contentBeforeSubmit: richTextBefore === null || richTextBefore === void 0 ? void 0 : richTextBefore.value,
        title
    });
};

export { useBloomreachNewsletterData };
//# sourceMappingURL=use-bloomreach-newsletter-data.js.map
